import React, { Fragment } from "react";
import { ErrorMessage, Field } from "formik";
import { METHOD, SEPA_ACCOUNT_OWNER, SEPA_BANK, SEPA_BIC, SEPA_IBAN } from "./field-names";
import { withNamespace } from "../../../../util/forms/with-namespace";
import { PaymentMethod } from "../../../../util/subscription/enums";
var PaymentMethodForm = function PaymentMethodForm(_ref) {
    var namespace = _ref.namespace, fieldValues = _ref.fieldValues;
    var stripe_styling = {
        style: {
            base: {
                fontFamily: 'Apex New',
                fontSize: '20px'
            }
        }
    }; // TODO: handle stripe token
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("label", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Zahlungsart"), /*#__PURE__*/ React.createElement("div", {
        className: "select-field"
    }, /*#__PURE__*/ React.createElement(Field, {
        as: "select",
        name: withNamespace(METHOD, namespace)
    }, /*#__PURE__*/ React.createElement("option", {
        value: PaymentMethod.SEPA
    }, "SEPA-Lastschrift"), /*#__PURE__*/ React.createElement("option", {
        value: PaymentMethod.TRANSFER
    }, "\xDCberweisung"), /*#__PURE__*/ React.createElement("option", {
        value: PaymentMethod.PAYPAL
    }, "Paypal")))), fieldValues[METHOD] == PaymentMethod.SEPA && /*#__PURE__*/ React.createElement("div", {
        className: "mt-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Kontoinhaber"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(SEPA_ACCOUNT_OWNER, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(SEPA_ACCOUNT_OWNER, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-4 sm:w-1/2 sm:pr-2"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "IBAN"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(SEPA_IBAN, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(SEPA_IBAN, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-4 sm:w-1/2 sm:pl-2"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "BIC"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(SEPA_BIC, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(SEPA_BIC, namespace),
        component: "div",
        className: "error-message"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Bank"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(SEPA_BANK, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(SEPA_BANK, namespace),
        component: "div",
        className: "error-message"
    }))), fieldValues[METHOD] == PaymentMethod.TRANSFER && /*#__PURE__*/ React.createElement("div", {
        className: "mt-10 text-base"
    }, "Die Zahlung per \xDCberweisung ist nur mit einem Bankkonto aus einem der aufgef\xFChrten L\xE4nder m\xF6glich. Bei \xDCberweisung aus einem anderen Land k\xF6nnen Geb\xFChren entstehen, die wir Ihnen in Rechnung stellen m\xFCssen.", /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mt-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-1/2"
    }, "\xD6sterreich (AT)", /*#__PURE__*/ React.createElement("br", null), "Belgien (BE)", /*#__PURE__*/ React.createElement("br", null), "Cypern (CY)", /*#__PURE__*/ React.createElement("br", null), "Estland (EE)", /*#__PURE__*/ React.createElement("br", null), "Finnland (FI)", /*#__PURE__*/ React.createElement("br", null), "Frankreich (FR)", /*#__PURE__*/ React.createElement("br", null), "Deutschland (DE)", /*#__PURE__*/ React.createElement("br", null), "Griechenland (GR)", /*#__PURE__*/ React.createElement("br", null), "Irland (IE)", /*#__PURE__*/ React.createElement("br", null), "Italien (IT)"), /*#__PURE__*/ React.createElement("div", {
        className: "w-1/2"
    }, "Lettland (LV)", /*#__PURE__*/ React.createElement("br", null), "Litauen (LT)", /*#__PURE__*/ React.createElement("br", null), "Luxemburg (LU)", /*#__PURE__*/ React.createElement("br", null), "Malta (MT)", /*#__PURE__*/ React.createElement("br", null), "Niederlande (NL)", /*#__PURE__*/ React.createElement("br", null), "Portugal (PT)", /*#__PURE__*/ React.createElement("br", null), "Slowakei (SK)", /*#__PURE__*/ React.createElement("br", null), "Slowenien (SI)", /*#__PURE__*/ React.createElement("br", null), "Spanien (ES)"))));
};
export default PaymentMethodForm;
